module.exports = __webpack_public_path__ + "img/onlineErp-1.3b1013e3.png";